export {
  HeroImageWrapper,
  HeroImageImg,
  HeroImageImgWithAnimation
} from './HeroImage.styles'
export { default } from './HeroImage'
